/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentRoundSummary {
  dateCreated?: Date;
  dateExecuted?: Date;
  dateScheduled?: Date;
  failureActivation?: number;
  failureActivationBenefit?: number;
  failureEdition?: number;
  failureEditionBenefit?: number;
  failurePayment?: number;
  failurePaymentBenefit?: number;
  failureValidation?: number;
  failureValidationBenefit?: number;
  finished?: number;
  finishedBenefit?: number;
  lastRound?: boolean;
  lastUpdated?: Date;
  paymentRoundId?: number;
  paymentSuccess?: number;
  paymentSuccessBenefit?: number;
  pendingPayment?: number;
  pendingPaymentBenefit?: number;
  subscriberCount?: number;
  totalProcessed?: number;
  totalProcessedBenefit?: number;
  totalSubscribers?: number;
  totalSubscribersBenefit?: number;
  username?: string;
  waitingActivation?: number;
  waitingActivationBenefit?: number;
  waitingEdition?: number;
  waitingEditionBenefit?: number;
  waitingPayment?: number;
  waitingPaymentBenefit?: number;
  waitingValidation?: number;
  waitingValidationBenefit?: number;
}
